import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValuePairModel } from '@em/models/restapi/KeyValuePair.Model';
import { EmRestApiService } from '@em/service/restapi/base/EmRestApi.Service';
import { ConfigurationService } from '@shared/service/configuration/Configuration.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { Observable } from 'rxjs';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class RestApiInfoService extends EmRestApiService {
    private _controller = 'info/';

    public constructor(
        private readonly _dialog: MatDialog,
        private readonly _config: ConfigurationService,
        private readonly _httpClient: HttpClient) {
        super(_dialog, _config.emRestApiBase, _httpClient);
    }

    public getSetting(name: string, category: string, process?: ProcessMonitorServiceProcess): Observable<KeyValuePairModel> {
        let params = new HttpParams();
        params = params.append('category', category);
        params = params.append('name', name);

        return this.get<KeyValuePairModel>(`${this._controller}getsetting`, KeyValuePairModel, params, process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }
}
